import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface CarouselProps {
  items: Team[];
}
interface Team {
  team_id: number;
  logo_url: string;
  name_short: string;
}

const Carousel: React.FC<CarouselProps> = ({ items }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="w-full  mt-5 px-14 mb-16 m-auto">
      <div className="">
        <Slider {...settings}>
          {items.map((team) => (
            // <TeamCard
            //   key={team.team_id}
            //   team_id={team.team_id}
            //   logo_url={team.logo_url}
            //   name_short={team.name_short}
            // />
            <div
              key={team.team_id}
              className="flex item-center justify-center items-center bg-highlight rounded "
            >
              <div className="flex flex-col items-center p-2 text-white">
                <img
                  src={team.logo_url}
                  alt={team.name_short}
                  className="w-12 h-12 object-contain"
                />
                <p className="text-center text-sm font-bold mt-5">
                  {team.name_short}
                </p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Carousel;

const PrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-full z-20 w-16 flex justify-center">
      <button
        className="group  p-1 flex justify-center items-center bg-highlight w-8 h-12 rounded-xl hover:shadow-[0_0_10px_white]"
        onClick={onClick}
      >
        <svg
          className="h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M10.0002 11.9999L6 7.99971L10.0025 3.99719"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

const NextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <div className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-full z-10 w-16 flex justify-center">
      <button
        className=" p-1 flex justify-center items-center bg-white/10 w-8 h-12 rounded-xl hover:shadow-[0_0_10px_white]"
        onClick={onClick}
      >
        <svg
          className="h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M5.99984 4.00012L10 8.00029L5.99748 12.0028"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};
